import React from 'react';
import { useAuth } from "../../contexts/AuthContext";
import EchangesList from '../EchangesList/EchangesList';
import TableauDeBord from '../TableauDeBord/TableauDeBord';

interface SuiviDuMarcheProps {
  commande: any;
  type?: 'MS' | 'BC';
}

const SuiviDuMarche: React.FC<SuiviDuMarcheProps> = ({ commande, type = 'MS' }) => {
  const { user } = useAuth();
  const title = type === 'BC' ? 'Suivi de la Commande' : 'Suivi du Marché';

  // Fonction pour formater la date au format français
  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Définition des colonnes pour le tableau d'historique
  const historiqueColumns = [
    {
      field: 'date',
      header: 'Date',
      renderCell: (_: any, row: any) => (
        <div className="date-cell">
          {formatDate(row.created_at)}
        </div>
      )
    },
    {
      field: 'action',
      header: 'Action',
      renderCell: (_: any, row: any) => (
        <div className="action-cell">
          {row.prefix || '-'}
        </div>
      )
    },
    {
      field: 'description',
      header: 'Description',
      renderCell: (_: any, row: any) => (
        <div className="description-cell">
          {row.label || '-'}
        </div>
      )
    }
  ];

  return (
    <div className="tab-suivi-marche">
      {/* <h2>{title}</h2> */}
      <section>
        <h3 className='section-header'>Historique</h3>
        <div className="section-content">
          {commande.historique && commande.historique.length > 0 ? (
            <TableauDeBord
              data={commande.historique}
              columns={historiqueColumns}
              searchPlaceholder="Rechercher dans l'historique"
              onSearch={() => {}}
              showActionsColumn={false}
              isSelectable={false}
            />
          ) : (
            <div className="empty-state">Aucun historique disponible</div>
          )}
        </div>
      </section>
      <section>
        <h3 className='section-header'>Mémos</h3>
        <div className="section-content">
          <EchangesList
            titre="Mémos"
            echanges={commande.notes || []}
            currentUser={user?.name || 'Utilisateur'}
            showCommentaireForm={true}
          />
        </div>
      </section>
    </div>
  );
};

export default SuiviDuMarche;